export const gcd = (a, b) => (a ? gcd(b % a, a) : b);
export const lcm = (a, b) => Math.abs(a * b) / gcd(a, b);
//# sourceMappingURL=math.js.map